if (!customElements.get('custom-hero')) {
  customElements.define(
    'custom-hero',
    class CustomHero extends HTMLElement {
      constructor() {
        super();
      }
    }
  );
}